import React from 'react';
import './KnowledgeLibraryLink.scss';
import { NumberEncodingService } from '../../utils/numberEncodingService';
import { paths } from '../../routing/path';

export interface KnowledgeLibraryLinkProps {
    contentId?: number;
    text?: string;
    isAdmin?: boolean;
}

export const KnowledgeLibraryLink = (props: KnowledgeLibraryLinkProps) => {

    if (!props.contentId || !Number.isFinite(props.contentId) || props.contentId <= 0) {
        return null;
    }

    const encodedId = NumberEncodingService.encode(props.contentId);
    const basePath = props.isAdmin
        ? paths.admin.knowledgeLibrary
        : paths.venues.grow.knowledgeLibrary;
    const href = `${basePath}?contentId=${encodedId}`;

    return (
        <a
            href={href}
            className="kl-link"
            target="_blank"
            rel="noopener noreferrer">
            {props.text || 'Learn more'}
        </a>
    );
};
